// Cascading Variants for Shopify Dawn Theme
// Intensiv.com.au

class CascadingVariants {
  constructor() {
    this.product = window.product || {};
    this.variants = this.product?.variants || [];

    if (this.variants.length > 0) {
      this.init();
    }
  }

  // Normalize option strings to avoid mismatches (spaces, case, etc.)
  normalizeValue(value) {
    return value ? value.toString().trim().replace(/\s+/g, ' ').toLowerCase() : '';
  }

  init() {
    this.variantSelectors = document.querySelectorAll('[data-option-selector]');
    if (this.variantSelectors.length < 2) return;

    this.addEventListeners();
    setTimeout(() => this.updateCascadingOptions(), 100);
  }

  addEventListeners() {
    const firstSelector = this.variantSelectors[0];

    if (firstSelector.tagName === 'FIELDSET') {
      const inputs = firstSelector.querySelectorAll('input[type="radio"]');
      inputs.forEach(input => {
        input.addEventListener('change', () => {
          if (input.checked) {
            setTimeout(() => this.updateCascadingOptions(), 150);
          }
        });
      });
    } else if (firstSelector.tagName === 'SELECT') {
      firstSelector.addEventListener('change', () => {
        setTimeout(() => this.updateCascadingOptions(), 150);
      });
    }
  }

  updateCascadingOptions() {
    const currentSelections = this.getCurrentSelections();

    for (let i = 1; i < this.variantSelectors.length; i++) {
      this.updateSelectorOptions(i, currentSelections.slice(0, i));
    }
  }

  getCurrentSelections() {
    return Array.from(this.variantSelectors).map(selector => {
      if (selector.tagName === 'SELECT') {
        const value = selector.value;
        return value && value !== '' && value !== 'null'
          ? this.normalizeValue(value)
          : null;
      } else if (selector.tagName === 'FIELDSET') {
        const checked = selector.querySelector('input[type="radio"]:checked');
        return checked ? this.normalizeValue(checked.value) : null;
      }
      return null;
    });
  }

  updateSelectorOptions(selectorIndex, previousSelections) {
    const selector = this.variantSelectors[selectorIndex];
    const availableValues = this.getAvailableValues(selectorIndex, previousSelections);

    this.updateOptionVisibility(selector, availableValues);
    this.autoSelectIfNeeded(selector, availableValues);
  }

  getAvailableValues(optionIndex, previousSelections) {
    const availableValues = new Set();

    this.variants.forEach(variant => {
      let matches = true;
      for (let i = 0; i < previousSelections.length; i++) {
        const prev = previousSelections[i];
        const variantVal = this.normalizeValue(variant[`option${i + 1}`]);
        if (prev && variantVal !== prev) {
          matches = false;
          break;
        }
      }

      if (matches && variant.available) {
        const optionValue = this.normalizeValue(variant[`option${optionIndex + 1}`]);
        if (optionValue) availableValues.add(optionValue);
      }
    });

    return Array.from(availableValues);
  }

  updateOptionVisibility(selector, availableValues) {
    if (selector.tagName === 'SELECT') {
      const options = selector.querySelectorAll('option');
      options.forEach(option => {
        if (option.value === '' || option.value === 'null') {
          option.style.display = '';
          option.disabled = false;
        } else if (availableValues.includes(this.normalizeValue(option.value))) {
          option.style.display = '';
          option.disabled = false;
        } else {
          option.style.display = 'none';
          option.disabled = true;
        }
      });
    } else if (selector.tagName === 'FIELDSET') {
      const inputs = selector.querySelectorAll('input[type="radio"]');
      inputs.forEach(input => {
        const label = selector.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        if (!label) return;

        if (availableValues.includes(this.normalizeValue(input.value))) {
          label.style.display = '';
          input.disabled = false;
        } else {
          label.style.display = 'none';
          input.disabled = true;
          input.checked = false;
        }
      });
    }
  }

  autoSelectIfNeeded(selector, availableValues) {
    const currentValue = this.getSelectorValue(selector);

    if (!currentValue || !availableValues.includes(currentValue)) {
      if (availableValues.length > 0) {
        this.selectValue(selector, availableValues[0]);
      }
    }
  }

  getSelectorValue(selector) {
    if (selector.tagName === 'SELECT') {
      const value = selector.value;
      return value && value !== '' && value !== 'null'
        ? this.normalizeValue(value)
        : null;
    } else if (selector.tagName === 'FIELDSET') {
      const checked = selector.querySelector('input[type="radio"]:checked');
      return checked ? this.normalizeValue(checked.value) : null;
    }
    return null;
  }

  selectValue(selector, value) {
    if (selector.tagName === 'SELECT') {
      selector.value = value;
      selector.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (selector.tagName === 'FIELDSET') {
      const inputs = selector.querySelectorAll('input[type="radio"]');
      inputs.forEach(input => (input.checked = false));

      let targetInput = Array.from(inputs).find(
  input => this.normalizeValue(input.value) === value
);

// If normalization mismatch, fall back to first available input
if (!targetInput && inputs.length > 0) {
  targetInput = inputs.find(input => !input.disabled);
}

if (targetInput) {
  targetInput.checked = true;
  targetInput.dispatchEvent(new Event('change', { bubbles: true }));
}
    }

    // Force Shopify’s variant system to refresh
    const variantRadios = document.querySelector('variant-radios');
    if (variantRadios) {
      variantRadios.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      productForm.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.cascadingVariants = new CascadingVariants();
});

document.addEventListener('shopify:section:load', () => {
  window.cascadingVariants = new CascadingVariants();
});
